import { Grid } from '@mui/material'
import Label from 'components/Label'
import { TabHealthContent } from 'components/TabTeenager/TabHealthContent'
import React from 'react'
import { TabTeenagerProps } from '../..'

export const TabHealth: React.FC<TabTeenagerProps> = ({ data }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Label text='Dados de saúde' v='h6' color='primary' bold />
      </Grid>
      {data && data.identAdolescente && data.identAdolescente.identificacaoAdolescente ? (
        <TabHealthContent data={data.identAdolescente} />
      ) : null}
    </Grid>
  )
}
